import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { rolesRoute, systemRolesRoute } from 'src/app/app-routing.module';
import { AppState } from 'src/app/app.reducer';
import { selectCurrentRoute } from 'src/app/app.selectors';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { RoleDetailSaveModel } from '../../role-details/models/role-detail-save.model';
import { AddRoleApiService } from '../services/add-role-api.service';
import * as AddRoleActions from './add-role.actions';

@Injectable()
export class AddRoleEffects {
   createRole$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddRoleActions.createRole),
         withLatestFrom(this.store.select(getSelectedAccountId), this.store.pipe(select(selectCurrentRoute))),
         switchMap(([action, accountId, route]) => {
            const path = route.url[0].path;
            const roleToSave: RoleDetailSaveModel = {
               ...action.role,
               accountId: path === systemRolesRoute ? null : accountId,
            };
            if (roleToSave.hasOwnProperty('rolePrivileges')) {
               delete roleToSave.rolePrivileges;
            }
            return this.addRoleApiService.create(roleToSave).pipe(
               map((executionResult) => {
                  return AddRoleActions.createRoleSuccess({
                     roleId: executionResult.data.role.roleId,
                  });
               }),
               catchError((error) => {
                  return of(AddRoleActions.createRoleFailure(error));
               })
            );
         })
      );
   });

   createroleSuccess$ = createEffect(
      () => {
         return this.actions$.pipe(
            ofType(AddRoleActions.createRoleSuccess),
            tap((result) => {
               this.dialogService.closeFormComponent();
               this.router.navigate([`/${rolesRoute}/${result.roleId}`]);
               this.snackbar.open('Role Created');
            })
         );
      },
      {
         dispatch: false,
      }
   );

   constructor(
      private actions$: Actions,
      private addRoleApiService: AddRoleApiService,
      private store: Store<AppState>,
      private snackbar: MatSnackBar,
      private dialogService: LcsDialogService,
      private router: Router
   ) {}
}
